import React from 'react'

const Banner = () => {
  return (
    <div className="bannerWrapper">
      <h1 className="bannerTitle">Level up your gaming experience</h1>
    </div>
  )
}

export default Banner